import styled from 'styled-components';
import Button from 'components/Button';

const StyledButton = styled(Button)`
  margin: 20px 0 0 20px;

  @media (max-width: 991px) {
    margin: 20px auto 0 auto;
  }
`;

export { StyledButton };
